import { render, staticRenderFns } from "./press.vue?vue&type=template&id=53f15cbe&scoped=true&"
import script from "./press.vue?vue&type=script&lang=js&"
export * from "./press.vue?vue&type=script&lang=js&"
import style0 from "./press.vue?vue&type=style&index=0&id=53f15cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f15cbe",
  null
  
)

export default component.exports